import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", () => {
	const section = document.querySelector(".section.our-partners");
	if (!section) {
		return;
	}

	const deferredRows = section.querySelectorAll(".partners-row--deferred");
	if (!deferredRows.length) {
		return;
	}

	const initialRows = section.querySelectorAll(".partners-row--initial");
	const initialItems = Array.from(section.querySelectorAll(".partners-row--initial .partner-item"));
	const deferredItems = Array.from(section.querySelectorAll(".partners-row--deferred .partner-item"));

	let firstSwitchTimerId = null;
	let loopTimerId = null;
	let isDeferredVisible = false;
	let isAnimating = false;

	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	const holdDuration = 5000;

	const clearItemStyles = (items) => {
		gsap.set(items, { clearProps: "opacity,transform,filter" });
	};

	const showDeferredRows = () => {
		section.classList.add("partners-expanded");
		deferredRows.forEach((row) => row.removeAttribute("aria-hidden"));
		initialRows.forEach((row) => row.setAttribute("aria-hidden", "true"));
		isDeferredVisible = true;
	};

	const showInitialRows = () => {
		section.classList.remove("partners-expanded");
		deferredRows.forEach((row) => row.setAttribute("aria-hidden", "true"));
		initialRows.forEach((row) => row.removeAttribute("aria-hidden"));
		isDeferredVisible = false;
	};

	const animateSwap = ({ outgoingItems, incomingItems, midwayAction, incomingFrom, incomingStaggerFrom }) => {
		isAnimating = true;

		gsap.timeline({
			onComplete: () => {
				clearItemStyles(outgoingItems);
				clearItemStyles(incomingItems);
				isAnimating = false;
			}
		})
			.to(outgoingItems, {
				opacity: 0,
				y: -22,
				scale: 0.9,
				rotationX: 18,
				filter: "blur(6px)",
				duration: 0.55,
				ease: "power3.in",
				stagger: {
					amount: 0.28,
					from: "center"
				}
			})
			.add(() => {
				midwayAction();
				gsap.set(incomingItems, incomingFrom);
			})
			.to(incomingItems, {
				opacity: 1,
				y: 0,
				scale: 1,
				rotationX: 0,
				filter: "blur(0px)",
				duration: 0.9,
				ease: "expo.out",
				stagger: {
					amount: 0.5,
					from: incomingStaggerFrom
				}
			});
	};

	const switchToDeferred = () => {
		if (isAnimating || isDeferredVisible) {
			return;
		}

		if (prefersReducedMotion || !initialItems.length) {
			showDeferredRows();
			return;
		}

		animateSwap({
			outgoingItems: initialItems,
			incomingItems: deferredItems,
			midwayAction: showDeferredRows,
			incomingFrom: {
				opacity: 0,
				y: 30,
				scale: 0.88,
				rotationX: -20,
				filter: "blur(8px)"
			},
			incomingStaggerFrom: "random"
		});
	};

	const switchToInitial = () => {
		if (isAnimating || !isDeferredVisible) {
			return;
		}

		if (prefersReducedMotion || !initialItems.length) {
			showInitialRows();
			return;
		}

		animateSwap({
			outgoingItems: deferredItems,
			incomingItems: initialItems,
			midwayAction: showInitialRows,
			incomingFrom: {
				opacity: 0,
				y: 26,
				scale: 0.9,
				rotationX: -16,
				filter: "blur(7px)"
			},
			incomingStaggerFrom: "edges"
		});
	};

	const toggleRows = () => {
		if (isDeferredVisible) {
			switchToInitial();
			return;
		}

		switchToDeferred();
	};

	const startRevealTimer = () => {
		if (firstSwitchTimerId || loopTimerId) {
			return;
		}

		firstSwitchTimerId = window.setTimeout(() => {
			toggleRows();
			loopTimerId = window.setInterval(toggleRows, holdDuration);
		}, holdDuration);
	};

	if ("IntersectionObserver" in window) {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						startRevealTimer();
						observer.disconnect();
					}
				});
			},
			{ threshold: 0.2 }
		);

		observer.observe(section);
	} else {
		startRevealTimer();
	}
});
